export const enrollmentCheckData = (reference, verificationAmount) => JSON.stringify({
  reference_id: reference,
  verification_amount: verificationAmount
});

export const authenticationValidationData = (jwt, storedProfile) => JSON.stringify({
  three_ds_token: jwt,
  stored_profile: storedProfile,
});
